module.exports = __webpack_public_path__ + "img/img_engineering_phone_img2.a253e743.png";